import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from 'components/Input';
import Button from 'components/Button';

import CIFields from './CIFields';

import TestSelectionDropdown from './TestSelectionDropdown';

import {
  ParameterDropdown,
  ParameterLevelDropdown
} from 'components/Dropdown';

import { numberOfSamplesValidator } from 'utilities/validators';

const SettingsFormComponent = props => (
  <div className="content-item" id="settings-form">
    <h2 className="header-page">
      Settings
    </h2>

    <ParameterDropdown
      form={props.form}
      label="Variable 1"
      name="primaryParameter"
      resetSecondaryParameter
      id="primary-parameter-dropdown"
      onChange={props.onPrimaryParameterChange}
    />

    {props.secondaryParameterDropdownVisible &&
      <ParameterDropdown
        isClearable
        onlyNumerical
        form={props.form}
        label="Variable 2"
        name="secondaryParameter"
        id="secondary-parameter-dropdown"
        onChange={props.onSecondaryParameterChange}
        primaryParameterName={props.primaryParameterName}
      />
    }

    {props.primaryParameterLevels &&
      <ParameterLevelDropdown
        name="primaryParameterLevel"
        id="parameter-level-dropdown"
        levels={props.primaryParameterLevels}
      />
    }

    {props.optionsControlsVisible &&
      <div>
        <TestSelectionDropdown id="test-selection-dropdown" />

        {props.samplesExist &&
          <CIFields />
        }

        <Field
          min={2}
          max={10000}
          type="number"
          pattern="\d+"
          component={Input}
          name="numberOfSamples"
          id="number-of-samples"
          validate={numberOfSamplesValidator}
          label="Number of Samples (from 2 to 10000)"
        />

        <div className="flex mb-15">
          <Button
            submit
            className="main-button--green mr-10"
            onClick={props.onGenerateSamplesClick}
            disabled={props.generateSamplesButtonDisabled}
          >

            Generate Samples
          </Button>

          <Button
            reset
            onClick={props.onResetClick}
            className="main-button--grey"
          >

            Reset
          </Button>
        </div>

        {props.showEmptyDatasetWarning &&
          <p className="opacity-50 text-center">
            Your dataset is currently empty, please remove a
            few filters or select a new dataset before continuing.
          </p>
        }
      </div>
    }
  </div>
);

SettingsFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  samplesExist: PropTypes.bool.isRequired,
  optionsControlsVisible: PropTypes.bool.isRequired,
  generateSamplesButtonDisabled: PropTypes.bool.isRequired,
  secondaryParameterDropdownVisible: PropTypes.bool.isRequired,

  primaryParameterName: PropTypes.string,
  primaryParameterLevels: PropTypes.array,

  onResetClick: PropTypes.func.isRequired,
  onGenerateSamplesClick: PropTypes.func.isRequired,
  onPrimaryParameterChange: PropTypes.func.isRequired,
  onSecondaryParameterChange: PropTypes.func.isRequired,

  showEmptyDatasetWarning: PropTypes.bool.isRequired
};

SettingsFormComponent.defaultProps = {
  primaryParameterLevels: null,
  primaryParameterName: null
};

export default SettingsFormComponent;
